// ── useConfirm — «Точно?» перед действием, вместо системного confirm() ──────
// Системное окно браузера выглядит чужим, не переводится вместе с приложением
// и на телефоне блокирует всё. Здесь — наше окно Confirm.
//   const [ask, confirmEl, askAsync] = useConfirm();
//   <button onClick={() => ask({ title: t("Удалить?"), confirmLabel: t("Удалить") }, doDelete)} />
//   if (!(await askAsync({ title: … }))) return;   — посреди async-функции
//   {confirmEl}

import { useCallback, useState } from 'react';
import Confirm from './Confirm';

export default function useConfirm(C) {
  const [req, setReq] = useState(null);
  const ask = useCallback((opts, onConfirm) => setReq({ ...opts, onConfirm }), []);
  // Ответ обещанием: true — подтвердили, false — отказались или закрыли окно.
  const askAsync = useCallback((opts) => new Promise((resolve) => {
    let answered = false;
    setReq({ ...opts, onConfirm: () => { answered = true; resolve(true); }, onDone: () => { if (!answered) resolve(false); } });
  }), []);
  const el = req ? <Confirm C={C} {...req} onClose={() => { req.onDone?.(); setReq(null); }} /> : null;
  return [ask, el, askAsync];
}
